import React from "react";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../hooks/useStore";
import moment from "moment";

import DataTablePropTypes from "./ComponentPropTypes";
import {TableContainer} from "./ComponentStyles";
import {CourierLink} from "../../_defaultComponents/CourierLink/CourierLink";
import {EmptyMessage} from "../../_defaultComponents/EmptyMessage/EmptyMessage";

const DataTable = ({
    data,
    setData,
    loading,
    setReloadData,
    currentPage,
    setCurrentPage,
    dataCount
}: DataTablePropTypes) => {
    const {t} = useTranslation([]);
    const stores = useStore();

    return (
        <>
            <TableContainer
                pagination={{
                    total: dataCount,
                    current: currentPage,
                    onChange: async page => {
                        setCurrentPage(page);
                    },
                    hideOnSinglePage: true,
                    showSizeChanger: false
                }}
                rowKey="_id"
                dataSource={data}
                data-testid="shiftTable"
                loading={loading}
                locale={{
                    emptyText: <EmptyMessage />
                }}
            >
                <TableContainer.Column
                    dataIndex="date"
                    title={t("fields.date", {ns: "common"})}
                    render={date => (
                        <span data-testid="date">
                            {!date ? "-" : moment(date).format("DD.MM.YYYY")}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="courier"
                    title={t("fields.city", {ns: "common"})}
                    render={courier => <span data-testid="date">{courier?.city.capitalize()}</span>}
                />
                <TableContainer.Column
                    dataIndex="courier"
                    title={t("fields.courier", {ns: "common"})}
                    render={courier => (
                        <span data-testid="date">
                            {stores.meStore.checkRole("courierDetail") ? (
                                <CourierLink target="_blank" to={`/couriers/${courier?._id}`}>
                                    {courier?.fullname}
                                </CourierLink>
                            ) : (
                                courier?.fullname
                            )}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="courier"
                    title={t("fields.identificationNumber", {ns: "common"})}
                    render={courier => <span data-testid="date">{courier?.tckn}</span>}
                />
                <TableContainer.Column
                    dataIndex="courier"
                    title={t("fields.phone", {ns: "common"})}
                    render={courier => <span data-testid="date">{courier?.cellPhone}</span>}
                />
            </TableContainer>
        </>
    );
};

export default DataTable;
